import {ThemeProvider} from '@primer/react-brand/esm'

import {LinkColumn} from './components/LinkColumn/LinkColumn'
import {Newsletter} from './components/Newsletter/Newsletter'
import {StaffToggleBar} from './components/StaffToggleBar/StaffToggleBar'
import {SubFooter} from './components/SubFooter/SubFooter'

import {
  ARIA_HEADING,
  LEGAL_NAV_LABEL,
  SELECT_LANGUAGE_LABEL,
  SOCIAL_NAV_LABEL,
  cookieConsentItems,
  newsletter,
  sections,
  socialLinks,
  subFooterLegalLinks,
} from './marketing-footer.data'
import type {MarketingFooterProps} from './marketing-footer.types'
import {buildLocaleConfig} from './utils/locale-config'

import styles from './MarketingFooter.module.css'

export function MarketingFooter(props: MarketingFooterProps) {
  const {
    cookieConsentEnabled = false,
    colorMode,
    currentLocale = 'en-us',
    localeOptions,
    showAdminToggle = false,
    isAdminModeOn = false,
    adminTogglePath,
    showUiOptOut = false,
    isUiOptedOut = false,
    uiOptOutTogglePath,
  } = props

  const effectiveColorMode = colorMode === 'dark' ? 'dark' : 'light'
  const localeConfig = buildLocaleConfig(localeOptions, currentLocale)
  const currentYear = new Date().getFullYear()
  const subFooter = {
    copyrightLabel: `\u00a9 ${currentYear} GitHub, Inc.`,
    copyrightYear: currentYear,
    legalLinks: subFooterLegalLinks(),
    cookieConsentItems: cookieConsentItems(),
  }

  return (
    <ThemeProvider colorMode={effectiveColorMode}>
      <footer className={styles.footer} role="contentinfo" data-analytics-category="Footer">
        <h2 className="visually-hidden">{ARIA_HEADING()}</h2>

        <div className={styles.container}>
          <div className={styles.topRow}>
            <Newsletter {...newsletter()} className={styles.newsletter} />

            <div className={styles.columns}>
              {sections().map(section => (
                <LinkColumn key={section.id} section={section} />
              ))}
            </div>
          </div>
        </div>

        <SubFooter
          subFooter={subFooter}
          legalNavLabel={LEGAL_NAV_LABEL()}
          socialNavLabel={SOCIAL_NAV_LABEL()}
          localeOverlayLabel={SELECT_LANGUAGE_LABEL()}
          socialLinks={socialLinks()}
          locale={localeConfig}
          cookieConsentEnabled={cookieConsentEnabled}
        />

        <StaffToggleBar
          showAdminToggle={showAdminToggle}
          isAdminModeOn={isAdminModeOn}
          adminTogglePath={adminTogglePath}
          showUiOptOut={showUiOptOut}
          isUiOptedOut={isUiOptedOut}
          uiOptOutTogglePath={uiOptOutTogglePath}
        />
      </footer>
    </ThemeProvider>
  )
}
